import { render, staticRenderFns } from "./LoginWithoutIcon.vue?vue&type=template&id=b9ba1d88&scoped=true&"
import script from "./LoginWithoutIcon.vue?vue&type=script&lang=ts&"
export * from "./LoginWithoutIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LoginWithoutIcon.vue?vue&type=style&index=0&id=b9ba1d88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba1d88",
  null
  
)

export default component.exports